import React from 'react'
import { Prompt } from 'react-router-dom'
import { useUnsavedChanges } from './UnsavedChangesContext'

const UnsavedChangesDialog: React.FC = () => {
  const { combinedIsDirty } = useUnsavedChanges()

  return (
    <Prompt
      when={combinedIsDirty}
      message={
        '変更内容が保存されていません。\n「OK」を押すと変更内容が破棄されます。よろしいですか？'
      }
    />
  )
}

export default UnsavedChangesDialog
